/* eslint-disable no-alert, no-console */


import {FETCH_CAS_TICKET,
  FETCH_JWT,
  ON_SUCCESSFUL_AUTHORIZATION,
  NOTIFY_AUTH_FAILURE,
  LOGOUT} from '../actions/auth'


const state = {
	token: localStorage.getItem("jwt-token") || '',
	casTicket: '',
	status: '',
	casLoginUrl: "https://shibboleth.qa.umd.edu/shibboleth-idp/profile/cas/login",
	casLogoutUrl: "https://shibboleth.qa.umd.edu/shibboleth-idp/profile/cas/logout",
	appUrl: location.protocol + '//' + location.host,
	authServerUrl: "https://8sb2icgohk.execute-api.us-east-1.amazonaws.com", // idmtools-userauthtokens DEV
	// authServerUrl: "https://cgnn9zbjwf.execute-api.us-east-1.amazonaws.com", //idmtools-userauthtokens ENG
	authenticated: false,
}

const getters = {
	isAuthorized: state => !!state.token,
	authStatus: state => state.status,
	jwt: state => state.token,
	jwtData: (state, getters) => state.token ? JSON.parse(atob(getters.jwt.split('.')[1])) : null,
	jwtSubject: (state,getters) => getters.jwtData ? getters.jwtData.sub : null,
	jwtScopes: (state,getters) => getters.jwtData.scope ?? []


}

const mutations = {
	[FETCH_CAS_TICKET]: state => {
		state.status = 'redirecting'
		location.replace(state.casLoginUrl + "?service=" + state.appUrl)
	},

	[FETCH_JWT]: (state, resp) => {
		state.status = 'fetching token'
		state.casTicket = resp.casTicket
		state.authenticated = true
	},

	[NOTIFY_AUTH_FAILURE]: state => {
		state.casTicket = ''
		state.token = ''
		state.status = 'unauthorized'
	},

	[ON_SUCCESSFUL_AUTHORIZATION]: (state, resp) => {
		state.status = 'authorized'
		state.casTicket = ''
		state.token = resp
		
		localStorage.setItem("jwt-token", state.token)
	},

	[LOGOUT]: state => {
		state.status = 'unauthorized'
		state.token = ''
		localStorage.removeItem('jwt-token')

	}
}

const actions = {
	[FETCH_CAS_TICKET]: ({commit}) => {
		commit(FETCH_CAS_TICKET)
	},

	[FETCH_JWT]: ({commit}, casTicket) => {
		// parse query string
		const axios= require('axios').create({
			baseURL: state.authServerUrl,
		})
		axios.interceptors.request.use(request => {
			console.log(`starting request`, request)
			return request
		})
		console.log("fetching jwt:\t " + casTicket)
		commit(FETCH_JWT, {casTicket: casTicket})
		const body =  {
			serviceUrl: state.appUrl,
			audience: "testuser-builder",
			ticket: casTicket
		}
		return new Promise((resolve) => {
			axios.post('/validate', body)
			.then((response) => {
				const token = response.data.token
				commit(ON_SUCCESSFUL_AUTHORIZATION, token)
				resolve()
			}).catch((error) => {
				console.log(error)
				commit(NOTIFY_AUTH_FAILURE)
				resolve(error)
			})
			
		})
		
		
	},

	[NOTIFY_AUTH_FAILURE]: () => {
		//display error message
	},

	[ON_SUCCESSFUL_AUTHORIZATION]: () => {
		
	},

	[LOGOUT]: ({commit}) => {
		return new Promise((resolve) => {
			commit(LOGOUT)
			
			resolve()
		})
	}
}


export default {
	state,
	getters,
	actions,
	mutations,
}